import VideoGeneration from './VideoGeneration'

export default VideoGeneration
